import { render, staticRenderFns } from "./historyorders.vue?vue&type=template&id=4f7b27a6&scoped=true"
import script from "./historyorders.vue?vue&type=script&lang=js"
export * from "./historyorders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b27a6",
  null
  
)

export default component.exports